import { OnInit } from '@angular/core';
var ProductSelectComponent = /** @class */ (function () {
    function ProductSelectComponent() {
    }
    ProductSelectComponent.prototype.ngOnInit = function () {
    };
    return ProductSelectComponent;
}());
export { ProductSelectComponent };
